import EventModel from '~/models/event.js'

export default class Task extends EventModel {
	static _routeKey = 'event'

	_logIcon() {
		return 'IconTaskDraftCircle'
	}

	tail = {
		duration: () => ['duration', this.duration != null ? this.durationHuman() : null],
		starts_at: () => ['due date', this.starts_at != null ? this.startHM() : null],
		ends_at: () => ['end date', this.ends_at != null ? this.endHM() : null],
		completed_at: () => ['completed at', this.vue.$help.formatDateTime(this.completed_at, { date: true, time: true }), ''],
		belongs_id: () => ['Associated deal', parseInt(this.belongs_type) != 102 ? this.belongs_id : 'No deal associated'],
		createdDescription: () => '"' + this.title + '" was created',
		virtual_ends_at: () => [null, null],
		// extra_keys: {
		//     belongs_id: () => (this.belongs_id ? ['Associated deal', this.belongs_id] : null),
		// },
	}

	me() {
		return 'Task'
	}

	timeline(user) {
		let t = this._timeline(user)
		let l = this.level('deal')

		return {
			title: this.published_at == null ? this.created_by.first_name + ' created a draft' : this.created_by.first_name + ' created a new task',
			description: this.title,
			created_at: this.created_at,
			icon: this.published_at == null ? 'IconTaskDraftCircle' : 'IconTaskCircle',
			breakdown: {
				title: this.title,
				description: this.description,
				status: {
					type: 'statusMenu',
					text: this.statusString(),
					circleClass: this.statusClass(),
					event: this,
					// icon: this.statusIconName(),
				},
				'due date': this.startHM(),
				// duration: this.durationHuman(),
				'Associated deal':
					l == false
						? null
						: {
								type: 'NuxtLink',
								to: l.link,
								text: l.title,
							},
			},
			options: {
				View: () => this.view(),
				Edit: () => this.edit(),
				'Mark as complete': this.canComplete() ? () => this.complete() : null,
				Delete: () => this.destroy(),
			},
		}
	}
}
